export default __webpack_public_path__ + "static/media/footerSao.e6633aae.png";